import RatesCalculator from "./calculator/RatesCalculator";

let $rates_calculator_content = $(".prs-content");
if($rates_calculator_content.length === 1){
    let rates_calculator = new RatesCalculator($rates_calculator_content);
    $rates_calculator_content.data("rates-calculator", rates_calculator)
}

function setTwoNumberDecimal(event) {
    this.value = parseFloat(this.value).toFixed(2);
}

$(document).ready(function()
{
    $("#contribution_txt").on('change', function()
    {
    	var current =  parseFloat(this.value).toFixed(2);
        this.value = current; // leave this - it changes .00000 to .00 in inputs

		$( "span.current-group-contribution" ).each(function( index ) 
		{
		  	var multiplier = $(this).data("multiplier");
		  	var outcome = current / multiplier;
		  	$(this).html(outcome);	
		});


    });
});